<circ-loader [isLoading]="loading">
  <legend>{{ 'step_details_legend' | i18n }}</legend>
  <div *ngIf="providerComponent">
    <ng-container *ngComponentOutlet="providerComponent"></ng-container>
  </div>
</circ-loader>
